<template>
  <div>
    <!-- Result Content -->
    <div class="row justify-content-center">
      <div class="card shadow customs-card mx-2">
        <!-- Result Label -->
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">
            結果発表
          </p>
        </div>

        <div
          class="card-body p-4 d-flex align-items-center justify-content-center"
        >
          <img
            :src="campaign.image_of_content_lose"
            alt="image_of_content_lose"
            class="img-fluid mx-auto d-block"
          />
        </div>

        <div class="border-0 mx-4 mb-4" v-if="is_shared">
          <div class="row">
            <div class="col-12 mb-3">
              <p
                class="m-0 text-center font-weight-bold"
                style="font-size: 1.2rem !important;"
              >
                お友達にキャンペーンを紹介して<br/>👇👇 再挑戦しよう！👇👇
              </p>
            </div>

            <div class="col-12 mt-2">
              <a
                @click="updateSharedStatus()"
                class="btn btn-block border-0 text-white text-bold font-weight-bold"
                style="border-radius: 1rem; background-color: #28a745; font-size: 1rem !important; box-shadow: 0 5px 0 #22903b;"
                >LINEでシェアして<br/>リトライする
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCampaignId,
  getCampaignContents,
  getCampaignImageContents,
  getCampaignCautions,
  getPrize,
  setState,
  setSharedLine,
  getSharedLine,
  getIsJoinShare,
  setIsJoinShare,
  setIsRetry,
  getIsRetry,
  getTimerId,
  setTimerId,
  setLinkShare,
  getLinkShare,
  getIsShared,
  setIsShared,
  getIsShareable
} from "@/utils/campaign";

import { setErrorMessage } from "@/utils/error";

import { retryCampaign, checkShareLine, sharedCampaign } from "@/api/campaign";

import Cautions from "@/components/Cautions.vue";

import store from "../store/index";

import { getUserAgentMobile } from "@/utils/auth";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      campaign: {
        name: "",
        image_of_content_top: "",
        image_of_content_lose: "",
      },
      cautions: "",
      line_share_url: (getUserAgentMobile() == 'true') ? process.env.LINE_SHARE_URL + getLinkShare() : process.env.LINE_SHARE_URL_PC + getLinkShare(),
      is_shared: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    //check prize existences if player win
    if (getPrize()) {
      // switch to /game-win if player lose
      return next("/game-win");
    }

    // add image url list
    const imagesList = [
      require("@/assets/img/campaign/image_of_content_top.jpg"),
      require("@/assets/img/campaign/image_of_content_lose.jpg"),
    ];

    // get campaign image url from cookies
    const imageContents = getCampaignImageContents();

    // push campaign image to imagesList array
    if (imageContents) {
      imageContents.forEach((image) => {
        if (image && (image.type == 30)) {
          // add only content lose image to imagesList - 30
          const imageUrl = process.env.BASE_API + image.image_of_content;
          imagesList.push(imageUrl);
        }
      });
    }

    // load every image
    const images = imagesList.map((imageSrc) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = imageSrc;
        img.onload = resolve;
        img.onerror = reject;
      });
    });

    Promise.all(images)
      .then(() => {
        console.log("All images loaded!");
      })
      .catch((error) => {
        console.error("Error getting image", error);
      })
      // TODO: solve the problem when one of all images not loaded and call next right away before loading all
      .finally(() => {
        return next((vm) => {
          // set caution data
          vm.setCampaignCautions(getCampaignCautions());
        });
      });

    // Get link share line
    checkShareLine({
      campaign_id: getCampaignId(),
      user_agent_mobile: getUserAgentMobile()
    }).then((data) => {
      if (data.result.url) {
        setLinkShare(data.result.url);
        let currentShared = data.result.share;
        setSharedLine(currentShared);
      }
    });
  },
  async created() {
    // Check user shared campaign to redirect to main page
    let isShared = getIsShared()
    if (parseInt(isShared) === 1) {
      // set state to not-play
      setState("not-play");
      setIsShared(0)
      return this.$router.push("/main");
    }

    const contents = getCampaignContents();
    const imageContents = getCampaignImageContents();
    // check campaign content existences from cookies and apply to data
    if (contents) {
      this.campaign.name = contents.name || "";
    }

    // check campaign image content existences from cookies and apply to data
    if (imageContents) {
      imageContents.forEach((image) => {
        if (image && (image.type == 30)) {
          // add only content lose image to imagesList - 30
          this.campaign.image_of_content_lose = process.env.BASE_API + image.image_of_content;
        }
      });
    } else {
      console.error(
        "No image contents found. Changing to default campaign images."
      );
    }

    // Set Share status
    setIsJoinShare(0);
    try {
      if (parseInt(getIsRetry()) === 1) {
        // Update retried
        setIsRetry(0);
        await retryCampaign({ campaign_id: getCampaignId(), is_update: 1 });
      }
      const isRetry = await retryCampaign({ campaign_id: getCampaignId() });
      if (isRetry.status === "success") {
        // check retry status
        if (isRetry.result.retry === 0) {
          setIsJoinShare(1);
          setIsRetry(0);
          this.is_shared = parseInt(getIsShareable());
        } else {
          clearInterval(getTimerId());
          setState("lose-retried");
        }
      } else {
        throw new Error(isRetry.message);
      }
    } catch (error) {
      console.error(error);
      return this.$router.push("/not-found");
    }
  },
  mounted() {
    // ブラウザバックを無効化する。window.history.pushStateでブラウザ履歴に現状のurlを上書き&ブラウザバックが押されたとき、履歴を1つ進むので実質無効化
    window.history.pushState(null, null, window.location.href)
      window.onpopstate = () => {
      window.history.go(1)
    }

    let timerId = setInterval(this.shareLine, 5000);
    setTimerId(timerId);
  },
  methods: {
    setCampaignCautions(cautions) {
      this.cautions = cautions;
    },
    async shareLine() {
      console.log("timer running ");
      // Store Total Share with Line
      if (parseInt(getIsJoinShare()) === 1) {
        let checkShare = await checkShareLine({
          campaign_id: getCampaignId(),
          user_agent_mobile: getUserAgentMobile()
        });
        if (checkShare.result) {
          let currentShared = checkShare.result.share;
          setSharedLine(currentShared);
          // Check user shared campaign to redirect to main page
          if (parseInt(getIsShared()) === 1) {
            setIsJoinShare(0);
            setIsRetry(1);
            clearInterval(getTimerId());
            // set state to not-play
            setState("not-play");
            setIsShared(0)
            return this.$router.push("/main");
          }
        }
      }
    },
    async updateSharedStatus() {
      store.dispatch("setLoading", true);
      await sharedCampaign({campaign_id: getCampaignId(), is_shared: 1})
      setIsShared(1)
      setIsJoinShare(1);
      store.dispatch("setLoading", false);

      window.location.href = this.line_share_url
    }
  },
};
</script>

<style scoped></style>
